import './Cabecalho.css'

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavLinks from './NavLinks';
import { Form } from 'react-bootstrap';

import { GlobalStyles } from '../Globalstyle'; 
import NavBar from './NavBar';
import Dashboards from '../Dashboards';
import I18n from '../I18n';
import { Translation } from 'react-i18next';
import Translator from '../I18n/Translator';

const Cabecalho = ({childToParent, themeToggler, theme, linguagem, ocultaLinks, origem}) => {

    return (
        <Navbar className='opaco' expand="lg" fixed='top'>
            <Container>
                <a href='/'>
                    <img className='aesop_logo' src="imagens/logo_aesop.png"   alt="Logotipo AESOP"/>
                </a>
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <div className='sub-titulo'> {ocultaLinks && origem != "/login" ? <Translator path={"dashboard.title"}  /> : ''}</div>
                <div className='sub-titulo2'> {ocultaLinks && origem != "/login" ? <Translator path={"dashboard.subtitle"}  /> : ''}</div>
                
                <Navbar.Collapse id="basic-navbar-nav">
                    <NavLinks linguagem = {linguagem} ocultaLinks = {ocultaLinks} origem = {origem}></NavLinks>
                    <div className='right_images'>
                        <div className='mini_icons'>
                            <I18n childToParent={childToParent} linguagem={linguagem} theme={theme}></I18n>
                            <div className={"switch_color " + theme} onClick={() => {themeToggler(); childToParent(linguagem);}}></div>
                        </div>

                        <div className="logos_direita">
                            <a href="https://portal.fiocruz.br/">
                                <img src="imagens/fiocruz-logo.png" className="img-fiocruz" alt="Fiocruz Logo"/>
                            </a>
                            <a href="https://www.gov.br/saude/pt-br">
                                <img src="imagens/ministerio_saude_logo_contorno.png" className="img-min-saude" alt="Ministério da Saúde Logo"/>
                            </a>
                        </div>  
                    </div>
      
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Cabecalho